import React, {ReactElement} from 'react';
import './cardButtonWithIcon.scss';
import {EmblaIcon} from "../emblaIcon/emblaIcon";
import {useMediaQuery} from "react-responsive";
import {mobileMaxWidthQuery} from "../../layout/responsive";
import Tooltip from '../tooltips/Tooltip';
import {EmblaIcons, EmblaIconsType} from 'core/emblaIcons';
import classNames from "classnames";
import {ConfirmButton} from "./confirmButton";
import DynamicButton from "./dynamicButton";

type CardButtonWithIconProps = {
    // Either an iconName for an EmblaIcon or a SVG (ReactElement):
    icon?: EmblaIconsType | ReactElement;
    isCreate?: boolean;
    additionalClasses?: string;
    buttonBottomText?: string;
    smallCard?: boolean;
    hideTooltip?: boolean;
    buttonBottomInfoText?: string;
    overrideColor?: string;
    confirmCallback: () => void;
    deleteCallback?: () => void;
    editCallback?: () => void;
}

export function CardButtonWithIcon({
                                       isCreate = false,
                                       smallCard = false,
                                       hideTooltip = false,
                                       deleteCallback,
                                       editCallback,
                                       overrideColor,
                                       ...props
                                   }: CardButtonWithIconProps) {
    const IsMobile = useMediaQuery(mobileMaxWidthQuery);

    return (
        <div
            className={`card button-card ${IsMobile ? "flex-fill" : "button-card-width"} ${props.additionalClasses ?? ""}`}
            onClick={() => props.confirmCallback()}>
            <div className="margin-s flex-container-column">
                <div
                    className={classNames("card-body d-flex", smallCard && "small-button-card-cube", "button-card-cube", isCreate ? "button-card-new" : "button-card-skabelon")}
                    style={{backgroundColor: overrideColor}}>
                    <div className="large flex-space-between">
                        {(typeof props.icon === "string")
                            ? <EmblaIcon additionalClasses={`large`} iconName={props.icon as EmblaIconsType}/>
                            : props.icon
                        }
                    </div>
                </div>
                <div className={classNames("flex-container-row flex-space align-items-center", deleteCallback && "margin-top-s")}
                     style={{overflowWrap: "anywhere"}}>
                    {props.buttonBottomText &&
                        <Tooltip className={"margin-top-xs"} title={props.buttonBottomText} show={!hideTooltip}>
                            <h5>{props.buttonBottomText} </h5>
                        </Tooltip>
                    }
                    <div className={"flex-container-row"}>
                        {editCallback &&
                            <DynamicButton
                                additionalClasses={classNames("margin-left-s flex-align-self-end")}
                                rounded
                                onClick={(e) => {
                                    e.stopPropagation();
                                    editCallback();
                                }}
                            >
                                <DynamicButton.TextIconItem
                                    iconName={EmblaIcons.Edit}/>
                            </DynamicButton>
                        }
                        {deleteCallback &&
                            <ConfirmButton
                                additionalClasses={"rounded-circle btn-icon margin-left-xs"}
                                icon={EmblaIcons.Delete}
                                asButton={true}
                                confirmCallback={deleteCallback}
                            />
                        }
                    </div>
                </div>
                {props.buttonBottomInfoText &&
                    <div className={"d-flex margin-top-xs"}>
                        <p className={"small"}>{props.buttonBottomInfoText} </p>
                    </div>
                }
            </div>
        </div>
    )
}
